module.exports = __webpack_public_path__ + "img/piece-complete-4.837c87e7.svg";